import { html, TemplateResult, LitElement, CSSResult, css } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map';
import { loadStyle } from '../api/ui';

@customElement('berner-infographic')
export class Bernerinfographic extends LitElement {
    private _initialized = false;

    @property()
    private subtitle = '';

    @property()
    private colour = '';

    @property()
    private value = '';

    @property({ attribute: 'display-change' })
    private displayChange = ''; 

    @property()
    private change = '';

    @property({ attribute: 'negative-change' })
    negativeChange = '';

    @property({ attribute: 'no-data' })
    noData = '';

    @property({ attribute: 'curtain-offline' })
    curtainOffline = '';

    get negative(): boolean {
        return this.negativeChange === 'true';
    }

    get noDataAvailable(): boolean {
        return this.noData === 'true';
    }

    get isCurtainOffline(): boolean {
        return this.curtainOffline === 'true';
    }

    // class css-loading is removed as soon as the external css is loaded
    public static get styles(): CSSResult {
        return css`
            .css-loading {
                display: none;
            }
        `;
    }

    firstUpdated = async (): Promise<void> => {
        await loadStyle('./css/berner-infographic.css', this.shadowRoot);
        this._initialized = true;
        this.requestUpdate();
    };

    renderContent(): TemplateResult {
        const UP_ARROW = '\u25B2';
        const DOWN_ARROW = '\u25BC';
        const CHANGE_PREFIX = this.negative ? DOWN_ARROW : UP_ARROW;
        const parsedChange = parseFloat(this.change);
        const showPrefix = !Number.isNaN(parsedChange) && parsedChange !== 0;

        return html`
            <section class="row mt-4">
                <div class="col-7 left-element">
                    <p class="title ${this.colour}">${this.title}</p>
                    <p class="subtitle">${this.subtitle}</p>
                </div>
                <div class="col-5 right-element">
                    <p class=${classMap({"value": !this.noDataAvailable, "value--small": this.noDataAvailable})}>${this.value}</p>
                    <p class="subtitle">
                        <span class=${classMap({"change": true, "d-none": this.noDataAvailable})}
                            >${showPrefix ? CHANGE_PREFIX : ""} ${this.displayChange}</span
                        >
                        <span class=${classMap({"d-none": !this.isCurtainOffline || !this.noDataAvailable})}>offline device</span>
                    </p>
                </div>
            </section>
        `;
    }

    render(): TemplateResult {
        return html`
        <link id="css-target">
        <div class="css-loading" id="root">
            <div class="col-lg-12 mx-auto my-3 no-gutters">
                ${this._initialized ? html`${this.renderContent()}` : html``}
            </div>
        </div>`;
    }
}
